import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-313daa92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "panel" }
const _hoisted_6 = {
  class: "panel-body",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = { style: {"min-width":"90px","min-height":"90px"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Numar intrare ", -1))
const _hoisted_11 = { class: "text__title--medium" }
const _hoisted_12 = { style: {"margin-left":"auto","min-height":"90px","display":"flex","align-items":"center"} }
const _hoisted_13 = { style: {"display":"flex","flex-direction":"column","min-width":"350px"} }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Termen raspuns: ")
], -1))
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "text__title--medium__black" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Timp ramas: ")
], -1))
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "text__title--medium__black" }
const _hoisted_22 = { style: {"display":"flex","align-items":"center","paddingleft":"25px","paddingright":"15px","paddingbottom":"15px"} }
const _hoisted_23 = { style: {"width":"65%","display":"flex","flex-direction":"row"} }
const _hoisted_24 = { style: {"display":"flex","flex-direction":"column","width":"100%","margin-left":"15px"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Sursa: ", -1))
const _hoisted_26 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Tip document: ", -1))
const _hoisted_28 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Nume prenume: ", -1))
const _hoisted_30 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "CNP / CUI: ", -1))
const _hoisted_32 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Email: ", -1))
const _hoisted_34 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Adresa: ", -1))
const _hoisted_36 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Titlu: ", -1))
const _hoisted_38 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Descriere: ", -1))
const _hoisted_40 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Numar file: ", -1))
const _hoisted_42 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Repartizat la: ", -1))
const _hoisted_44 = {
  class: "col-9 text__title--medium",
  style: {"color":"#2f6cb7"}
}
const _hoisted_45 = { style: {"width":"35%","display":"flex","flex-direction":"row"} }
const _hoisted_46 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_47 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente atasate", -1))
const _hoisted_49 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_52 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_55 = { class: "mobile-only" }
const _hoisted_56 = {
  clas: "row",
  style: {"margin-top":"15px"}
}
const _hoisted_57 = { class: "q-pa-sm" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_59 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingDocumentCetateniData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", { src: _ctx.getLinkToQrCode }, null, 8, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                    }, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.documentcetateni.id_doc) + " / " + _toDisplayString(_ctx.documentcetateni.data_doc), 1)
                    ], 2),
                    _createVNode(_component_q_btn, {
                      color: "white",
                      "text-color": "black",
                      "icon-right": "print",
                      label: "Tipareste!",
                      disable: _ctx.loadingPdfForDownload,
                      "no-caps": "",
                      loading: _ctx.loadingPdfForDownload,
                      onClick: _ctx.prepareCoverPdfForDownload
                    }, {
                      loading: _withCtx(() => [
                        _createVNode(_component_q_spinner_gears, { class: "on-right" }),
                        _createTextVNode(" Pregatire... ")
                      ]),
                      _: 1
                    }, 8, ["disable", "loading", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.documentcetateni.termen == "Fara termen"
                          ? _ctx.documentcetateni.termen
                          : _ctx.displayData(_ctx.documentcetateni.termen_date as string)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.documentcetateni.termen == "Fara termen"
                            ? "-"
                            : _ctx.documentcetateni.termen_zi) + " zile", 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-bottom":"5px"}
                    }, [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.documentcetateni.sursa), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_27,
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.getDenTipDocument(_ctx.documentcetateni.id_tip_document as number)), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.documentcetateni.nume_denumire), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.documentcetateni.cui), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_33,
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.documentcetateni.email_solicitant), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_35,
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.documentcetateni.adresa), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_37,
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.documentcetateni.titlu), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_39,
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.documentcetateni.descriere), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_41,
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.documentcetateni.nr_file), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  }),
                      style: {"margin-top":"5px","margin-bottom":"5px"}
                    }, [
                      _hoisted_43,
                      _createElementVNode("span", _hoisted_44, [
                        _createElementVNode("div", {
                          style: {"display":"flex","align-items":"center","flex-wrap":"wrap"},
                          class: _normalizeClass({ 'lista_departamente_de_repartizat-mobile': _ctx.$q.platform.is.mobile, 'lista_departamente_de_repartizat-desktop': _ctx.$q.platform.is.desktop })
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repartizari.filter((item) => item.appid_org_destinatar != null), (repartizare, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "departament_repartizat",
                              key: index
                            }, [
                              _createElementVNode("div", null, _toDisplayString(repartizare.den_org_destinatar), 1)
                            ]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repartizari.filter((item) => item.appid_user_destinatar != null), (repartizare, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "departament_repartizat",
                              key: index
                            }, [
                              _createElementVNode("div", null, _toDisplayString(repartizare.nume_prenume_user_destinatar), 1)
                            ]))
                          }), 128))
                        ], 2)
                      ])
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                    }, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", null, [
                          _hoisted_48,
                          _withDirectives(_createElementVNode("div", _hoisted_49, " Nimic atasat ", 512), [
                            [_vShow, 
                          _ctx.documentcetateni.scans != null &&
                          _ctx.documentcetateni.scans.length == 0 &&
                          !_ctx.uploadingFileToServer
                        ]
                          ])
                        ]),
                        (_ctx.user.auth_for_upload_scan == 'y')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createVNode(_component_q_btn, {
                                flat: "",
                                color: "primary",
                                icon: "add_box",
                                "no-caps": "",
                                disable: _ctx.loadingDocumentCetateniData,
                                onClick: _ctx.openFormUploadFile
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tooltip, {
                                    "transition-show": "rotate",
                                    "transition-hide": "rotate"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Incarca document nou ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disable", "onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", null, [
                          (_ctx.uploadingFileToServer)
                            ? (_openBlock(), _createBlock(_component_q_spinner, {
                                key: 0,
                                color: "primary",
                                size: "3em",
                                thickness: 10
                              }))
                            : (_openBlock(), _createElementBlock("table", _hoisted_52, [
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentcetateni.scans, (scan) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: scan.appid
                                    }, [
                                      _createElementVNode("td", null, [
                                        (_ctx.user.is_admin == 'y' || _ctx.user.auth_for_deletedocument == 'y')
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: "material-icons cursor-pointer",
                                              style: {"color":"red","font-size":"1.3rem"},
                                              onClick: ($event: any) => (_ctx.askIfRemoveScan(scan))
                                            }, "delete_forever", 8, _hoisted_53))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(scan.file_ext), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.file_size)), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_54, _toDisplayString(scan.description), 1),
                                        _createElementVNode("div", _hoisted_55, _toDisplayString(scan.description), 1)
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_q_btn, {
                                          round: "",
                                          color: "black",
                                          icon: "cloud_download",
                                          size: "xs"
                                        }),
                                        _createVNode(_component_q_menu, {
                                          fit: "",
                                          "transition-show": "scale",
                                          "transition-hide": "scale"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DialogOpenScan, {
                                              appid: scan.appid,
                                              type_scan: "Document"
                                            }, null, 8, ["appid"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                        ])
                      ])
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      label: "Preiau in lucru",
                      style: {"margin-left":"10px","color":"gray"}
                    }),
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      label: "Creaza document iesire",
                      style: {"margin-left":"15px","color":"gray"}
                    }),
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      label: "Prelucreaza",
                      style: {"margin-left":"15px","color":"gray"}
                    }),
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      label: "Ataseaza",
                      style: {"margin-left":"15px","color":"gray"}
                    })
                  ])
                ])
              ])
            ])
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUploadFile,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_linear_progress, {
              value: 0.6,
              color: "pink"
            }),
            _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
              default: _withCtx(() => [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_q_input, {
                    counter: "",
                    outlined: "",
                    modelValue: _ctx.uploadScanTitle,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                    label: "Titlu document (minim 4 caractere)",
                    dense: "",
                    maxlength: "200"
                  }, null, 8, ["modelValue"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "file",
                  name: "fileToUpload",
                  id: "fileToUpload",
                  ref: "myFileToUpload",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prepareForUpload($event))),
                  style: {"margin-bottom":"10px"}
                }, null, 544), [
                  [_vShow, _ctx.uploadScanTitle.length > 3]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  disable: !(_ctx.uploadScanTitle.length>3),
                  icon: "cloud_upload",
                  color: "white",
                  "text-color": "black",
                  label: "Salveaza pe server",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadFile())),
                  loading: _ctx.uploadingFileToServer,
                  style: {"margin-bottom":"5px"}
                }, null, 8, ["disable", "loading"]), [
                  [_vShow, _ctx.checkIfFileIsSelected]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}